import React, { Component } from "react";
import { Menu } from "antd";
import { queryApprovalUserCached } from '../../common/permissionCache';

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        let current = 'record';
        if (props.selectKey) {
            current = props.selectKey;
        }
        this.state = {
            current,
            haveStandardVisitUnitPriceMenu: false,
            haveEvaluateMenu: false,
            isDesignatedTal: false,
            isClinicalBO: false,
        };
    }

    componentDidMount() {
        this.queryApprovalUser();
    }

    // 获取标准访视单价菜单权限
    queryApprovalUser = () => {
        queryApprovalUserCached(undefined, res => {
            const { haveStandardVisitUnitPriceMenu, haveEvaluateMenu, isDesignatedTal, isClinicalBO } = res;
            this.setState({
                haveStandardVisitUnitPriceMenu,
                haveEvaluateMenu,
                isDesignatedTal,
                isClinicalBO,
            });
        });
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render () {
        const { current, haveStandardVisitUnitPriceMenu, haveEvaluateMenu, isDesignatedTal, isClinicalBO } = this.state;
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe8cd;</i><span>临床评估</span></span>}>
                        {haveStandardVisitUnitPriceMenu &&
                            <Menu.Item key="price">
                                <a href="#/clinicalEvaluation/standardVisitPrice">标准访视单价</a>
                            </Menu.Item>
                        }
                        {(isDesignatedTal || isClinicalBO) && <Menu.Item key="hours">
                            <a href="#/clinicalEvaluation/VisitingHours">访视工时</a>
                        </Menu.Item>}
                        {haveEvaluateMenu && <Menu.Item key="record">
                            <a href="#/clinicalEvaluation/clinicalEvaluationRecord">临床评估记录</a>
                        </Menu.Item>}
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/SideNav.js